import moment from 'moment';
import { MINIMUM_SUPPORTED_YEAR } from '../../../../../../shared/constants/decisionUpload';
import { aggregateDate } from '../../../../utils/date-utils/dateUtils';
import { Fields } from '../../decisionUpload.api';

type UploadData = {
  juridiction: string;
  city: string;
  number: string;
  day: string;
  month: string;
  year: string;
  file: File | undefined;
};

export const shouldHaveCity = (
  juridiction: string,
  jurisdictionsKeys: string[],
) => !!juridiction && jurisdictionsKeys.indexOf(juridiction) < 0;

export function getErrors(
  fields: {
    juridiction: string;
    city: string;
    number: string;
    day: string;
    month: string;
    year: string;
    file: File | undefined;
  },
  jurisdictionsKeys: string[],
): { [s: string]: Array<string> } {
  const validators = {
    juridiction: (values: UploadData) =>
      !values.juridiction ? ['UNDEFINED'] : [],
    number: (values: UploadData) => (!values.number ? ['UNDEFINED'] : []),
    city: (values: UploadData) =>
      shouldHaveCity(values.juridiction, jurisdictionsKeys) && !values.city
        ? ['UNDEFINED']
        : [],
    file: (values: UploadData) => (!values.file ? ['UNDEFINED'] : []),
    day: (values: UploadData) => (!values.day ? ['UNDEFINED'] : []),
    month: (values: UploadData) => (!values.month ? ['UNDEFINED'] : []),
    year: (values: UploadData) => {
      const errors = [];
      if (!values.year) {
        errors.push('UNDEFINED');
      } else if (!/^\d{4}$/.test(values.year)) {
        errors.push('WRONG_YEAR');
      }
      return errors;
    },
    date: (values: UploadData) => {
      const errors = [];
      if (!values.day) {
        errors.push('UNDEFINED_DAY');
      }
      if (!values.month) {
        errors.push('UNDEFINED_MONTH');
      }
      if (!values.year) {
        errors.push('UNDEFINED_YEAR');
      } else if (!/^\d{4}$/.test(values.year)) {
        errors.push('WRONG_YEAR');
      } else if (parseInt(values.year, 10) < MINIMUM_SUPPORTED_YEAR) {
        errors.push('INVALID_DATE');
      }

      if (values.day && values.month && values.year) {
        const date = aggregateDate(
          parseInt(values.day, 10),
          values.month,
          parseInt(values.year, 10),
        );

        const isDateInFuture =
          moment(0, 'HH').diff(moment(date, 'DD/MM/YYYY'), 'days') < 0;

        if (isDateInFuture) {
          errors.push('FUTURE_DATE');
        }
      }

      return errors;
    },
  };

  return Object.keys(validators).reduce(
    (acc: { [s: string]: Array<string> }, name) => {
      acc[name] = validators[name as keyof typeof validators](fields);
      return acc;
    },
    {},
  );
}

export const getDataFormated = (
  values: UploadData,
  jurisdictionsKeys: string[],
): Fields => {
  const data: {
    juridiction: string;
    numero_affaire: string; // eslint-disable-line camelcase
    date_dec: string; // eslint-disable-line camelcase
    ville?: string | null;
    file: File | undefined;
  } = {
    juridiction: values.juridiction,
    numero_affaire: values.number,
    date_dec: aggregateDate(
      parseInt(values.day, 10),
      values.month,
      parseInt(values.year, 10),
    ),
    file: values.file,
  };
  if (shouldHaveCity(values.juridiction, jurisdictionsKeys)) {
    data.ville = values.city;
  }
  return data;
};
